import script from "./AllocationTable.vue?vue&type=script&setup=true&lang=js"
export * from "./AllocationTable.vue?vue&type=script&setup=true&lang=js"

import "./AllocationTable.vue?vue&type=style&index=0&id=260a847d&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-260a847d"]])

export default __exports__